import React from "react";
import { Section } from "../../../components/section";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { ExternalLink } from "../../../components/external-link";

export interface FooterProps {
    sectionId: string;
    onNav: (anchor: string) => void;
}

export function Footer(props: FooterProps) {
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <ParagraphGroup
                title="Questions, Comments, Concerns?"
                body={
                    [
                        "This work was completed as part of the Master of Human Computer Interaction program at Carnegie Mellon University. Please reach out to us on LinkedIn, and we will be happy to build upon or elaborate on any part of this project. "
                    ]
                }
            />
            <ExternalLink
                url="/about#team"
                cta="Contact Us"
                internal={true}
                solo={true}
                onNav={props.onNav}
            />
        </Section>
    );
}
